import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { DashboardLayout } from 'src/components/dashboard/dashboard-layout';
import NetWorth from 'src/components/net-worth/net-worth';
import { ClientPortalAccounts } from 'src/features/client-portal/components/accounts/accounts';
import { CLIENT_PORTAL_HOME_ROUTE } from 'src/features/client-portal/components/shell/constants';
import { ClientPortalVersionPending } from 'src/features/client-portal/components/version-pending';
import { useClientPortalRedesign } from 'src/features/client-portal/hooks/use-client-portal-redesign';
import { portfolioSurface } from 'src/features/client-portal/utils/portfolio-surface';
import { withClientGuard } from 'src/hocs/with-client-guard';

import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';

function Portfolio(props: { readonly clientUserId: string }) {
  const router = useRouter();
  const { user } = useAuth();
  const surface = portfolioSurface({
    accountsDecision: useClientPortalRedesign('accounts'),
    homeDecision: useClientPortalRedesign('home'),
    role: user?.role,
  });

  useEffect(() => {
    if (surface === 'redesigned-home') {
      void router.replace(CLIENT_PORTAL_HOME_ROUTE);
    }
  }, [surface, router]);

  if (surface === 'pending') {
    return <ClientPortalVersionPending />;
  }

  if (surface === 'redesigned-home') {
    return null;
  }

  if (surface === 'accounts') {
    return (
      <DashboardLayout>
        <ClientPortalAccounts />
      </DashboardLayout>
    );
  }

  return <NetWorth {...props} />;
}

export default withClientGuard(Portfolio, { includeNonAdvisoryUser: true });
